export default {
      id: "check-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#check",
      toString: function () {
        return this.url;
      }
    }